import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { ITermsAndPolicyEntity } from '@web-nx-ng-tsc/web-shared-data-access';

@Component({
  selector: 'lib-web-shared-ui-warranty-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lib-warranty-policy.component.html',
  styleUrl: './lib-warranty-policy.component.scss',
})
export class LibWarrantyPolicyComponent {
  @Input() set data(value: ITermsAndPolicyEntity[]) {
    this.dataSignal.set(value);
  }

  dataSignal = signal<ITermsAndPolicyEntity[]>([]);
}
